import { render } from "./orderView.vue?vue&type=template&id=81c9adde&scoped=true"
import script from "./orderView.vue?vue&type=script&lang=js"
export * from "./orderView.vue?vue&type=script&lang=js"

import "./orderView.vue?vue&type=style&index=0&id=81c9adde&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c9adde"]])

export default __exports__